export const IID_SERIAL_NUMBER_IN_USE = 'ImprivataIdSerialNumberInUse';
export const TIMEOUT = 'timeout';
export const UNMET_AUTHENTICATION_REQUIREMENTS = 'unmet_authentication_requirements';
export const AUTH_ON_OTHER_DEVICE = 'AuthOnOtherDevice';
